import { memo as Memo, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const ZiggyJump = Memo(({ animate }) => {
	const rootRef = useRef(null);
	const flRef = useRef(null);
	const frRef = useRef(null);
	const animRef = useRef(null);

	useEffect(() => {
		const ctx = gsap.context(() => {
			const tl = gsap.timeline({ paused: true });

			tl.to(rootRef.current, { duration: 0.2, y: -20 })
				.to(flRef.current, { duration: 0.2, svgOrigin: '92 123', rotation: 30 }, 0)
				.to(frRef.current, { duration: 0.2, svgOrigin: '141 123', rotation: -30 }, 0)
				.to(rootRef.current, { duration: 0.2, y: 0 }, 0.2)
				.to(flRef.current, { duration: 0.2, svgOrigin: '92 123', rotation: 0 }, 0.2)
				.to(frRef.current, { duration: 0.2, svgOrigin: '141 123', rotation: 0 }, 0.2);

			animRef.current = tl;
		}, rootRef);

		return () => ctx.revert();
	}, []);

	useEffect(() => {
		if (animate && animRef.current) {
			animRef.current.progress(0).play();
		}
	}, [animate]);

	return (
		<svg
			ref={rootRef}
			className={`svg-max ziggyJump`}
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 221.63 184.43'>
			<path
				ref={flRef}
				className={`ziggyJump-fl defaultStyle`}
				d='M92.45,123.61c10.48,13.94,10.62,21.24,8.62,25.35-3.35,6.91,1.86,13.95,2,17.24a136.55,136.55,0,0,1,0,13.9c-8,.94-11.9,1.89-19.85,2.83'
			/>
			<path
				ref={frRef}
				className={`ziggyJump-fr defaultStyle`}
				d='M141.26,123.61c-10.48,13.94-10.61,21.24-8.62,25.35,3.35,6.91-1.85,13.95-2,17.24a133.32,133.32,0,0,0,0,13.9c8,.94,11.89,1.89,19.84,2.83'
			/>
			<path
				className={`ziggyJump-b fill`}
				d='M96.8,33.34,124.63,0l10.71,43.59L172.8,22.3l-.41,35.48,40.76-5.6L196.58,84l25,17.69-31.88,9.42-1.93,32.24-33.26-22.51L142.94,154.1l-25.25-29.84L89.87,148l-15-35.52-41.7,12.82,8-37.82L0,76.34l39.45-15L23.81,19.47l35.51,20L67,3.31Z'
			/>
		</svg>
	);
});

export default ZiggyJump;
